module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#facebook",
      toString: function () {
        return this.url;
      }
    }